import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    modalHeadline: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
    modalListWrapper: {
      paddingInlineStart: theme.spacing(2),
    },
    marginTopAdjustment: {
      marginTop: theme.spacing(-2),
    },
  })
)
